import { useEffect, useState } from "react";
import Foods from "../../data/Foods";
import Nuts from "../../data/Nutrients";
import FactRow from "./FactRow";
import FactsheetToolbar from "./FactsheetToolbar";
import { IFood } from "../../shared/IFood";
//https://fdc.nal.usda.gov/food-details/1750339/nutrients

export default function Factsheet(props:{foodId:number}){
    const [factor,setFactor] = useState<number>(1)
    const [food,setFood] = useState<IFood>(Foods.i.row(props.foodId.toString()))
    const items = food?.facts.map(fact => {
        const nut = Nuts.i.row(fact.nid.toString())
        if (nut) return <FactRow key={fact.nid} nut={nut} amount={fact.amount*factor}/>
        else return null
    }).filter(item => !!item)
    const onUpdate = (factor:number) => { console.log("factor", factor); setFactor(factor) }
    const onRefresh = () => setFood(Foods.i.row(props.foodId.toString()))
    useEffect(() => {
        Foods.i.on("update", onRefresh)
        return () => { Foods.i.removeListener("update", onRefresh) }
    },[])
    return items ? <><FactsheetToolbar food={food} onUpdateFactor={onUpdate}/><div className="factsheet">{items}</div></>
        : <div className="notfound">Not found</div>
}